import {Editor, TLImageShapeProps} from "@tldraw/tldraw";
import {useCallback, useRef} from "react";
import {GetImagesParams} from "../types/taskFlow.types";
import {cleanLocalForage, getLocalForage, setLocalForage} from "../util/storage";

export const useLazyLoad = (editor: Editor | undefined) => {

    const loadedImages = useRef<Set<string>>(new Set());

    const replaceDomImageSrc = useCallback(async (imgShapeId: string, originUrl: string, isBlob: boolean, blob?: Blob)=>{
        const targetImage = document.querySelector(`div[data-shape-id="${imgShapeId}"] img`);
        if (!targetImage) return;
        if (isBlob) {
            if (blob) {
                await cleanLocalForage(100);
                await setLocalForage(imgShapeId, blob)
            }
            targetImage.setAttribute('src', originUrl);
        }else {

            // 预加载图片
            const img = new Image();
            img.src = originUrl as string;


            // 当图片加载完成后，更新画布中的图片
            img.onload = () => {
                // 更新资产数据 - 替换为高质量图片
                // shape:vdhET3w26i6xP-J6u8Dxc
                /*                        editor.updateAssets([{
                                            ...imageShape,
                                            props:{
                                                ...imageShape.props,
                                                src: originUrl as string
                                            }
                                        }]);*/

                targetImage.setAttribute('src', originUrl);

                console.log(`已加载原始图片: ${imgShapeId}`);
            };

            // 处理加载错误
            img.onerror = () => {
                console.error(`无法加载原始图片: ${originUrl}`);
            };
        }
    }, [])

    const loadVisibleImages = useCallback(async () => {
        if (!editor) return []
        try {
            // 获取当前的zoom
            const zoom = editor.getZoomLevel();

            if (zoom < 0.7) return []

            // 获取当前视口的页面边界
            const viewportBounds = editor.getViewportPageBounds();

            // 获取快照中的所有形状
            const snapshot = editor.getCurrentPageShapes();

            // 筛选出图片类型的形状
            const imageShapes = snapshot.filter((shape) => {
                return shape && shape.type === 'image';
            });

            // 检查哪些图片在视口内
            const visibleImages = imageShapes.filter((shape) => {
                try {
                    const shapeBounds = editor.getShapePageBounds(shape.id);

                    if (!shapeBounds) return false;

                    // 判断图片是否与视口有任何重叠（即图片有部分在视口内）
                    return (
                        // 水平方向有重叠
                        (viewportBounds.minX <= shapeBounds.maxX && viewportBounds.maxX >= shapeBounds.minX) &&
                        // 垂直方向有重叠
                        (viewportBounds.minY <= shapeBounds.maxY && viewportBounds.maxY >= shapeBounds.minY)
                    );
                } catch (e) {
                    console.error('检查图片可见性时出错:', e);
                    return false;
                }
            });

            return (await Promise.all(visibleImages.map(async (imgShape) => {
                const assetId = (imgShape.props as TLImageShapeProps).assetId!;
                const imageShape = editor.getAsset(assetId);
                const uuid = imageShape?.meta?.uuid;
                const cacheBlob = await getLocalForage(imgShape?.id);

                if (cacheBlob) {
                    const imgUrl = URL.createObjectURL(cacheBlob as Blob);
                    await replaceDomImageSrc(imgShape?.id, imgUrl, true)
                    return null
                }

                if (!uuid || loadedImages.current.has(uuid as string))
                    return null;
                loadedImages.current.add(uuid as string);
                return {
                    uuid: uuid as string,
                    extra: {shapeId: imgShape?.id}
                };
            }))).filter(shape => shape !== null) as GetImagesParams[];
        } catch (e) {
            console.error('懒加载图片时出错:', e);
            return [];
        }
    }, [editor]) ;

    return {
        loadVisibleImages,
        replaceDomImageSrc
    }
}